import React from "react";
import {Button, Tooltip} from "antd";
import { Link } from 'react-scroll'
import Panel from "@/page-components/home/Fast_nav/panel";
import styles from './styles.module.less';

type TFastNav = {
  left: number;
}

const FastNav:React.FC<TFastNav> = ({left}) => {
  return (
    <>
      <div className={styles.fast_nav_wrapper} style={{left: `${left}px`}}>
        <Link activeClass={styles.active} to="anchor1" spy smooth duration={500} >
          <div className={styles.item}>
            报考说明
          </div>
        </Link>
        <Link activeClass={styles.active} to="anchor2" spy smooth duration={500} >
          <div className={styles.item}>
            认证概述
          </div>
        </Link>
        <Link activeClass={styles.active} to="anchor3" spy smooth duration={500} >
          <div className={styles.item}>
            考试安排
          </div>
        </Link>
        <Link activeClass={styles.active} to="anchor4" spy smooth duration={500} >
          <div className={styles.item}>
            学习资料
          </div>
        </Link>
        <Link activeClass={styles.active} to="anchor5" spy smooth duration={500} >
          <div className={styles.item}>
            常见问题
          </div>
        </Link>
      </div>
      <Tooltip placement="right" title={Panel} color="white">
        <Button type="primary" className={styles.ask_btn} style={{left: `${left}px`}}>
          <img src="/img/ico_chat.png" width="16" height="16" alt="kefu" />
          <p className={styles.icon_text}>在线咨询</p>
        </Button>
      </Tooltip>
    </>
  )
}
export default FastNav;
